import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  initialiseCardoList as initialiseCardoListAction,
  showMore as showMoreAction,
  hideShowMore as hideShowMoreAction,
} from '../modules';

const CardoListContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

const getCardoListData = ({ content, data }) => {
  if (typeof data === 'string') {
    // Fetch from the redux store
    // TODO: [1] the redux store implementation needs to be modified to be compatible with multiple cardoLists
    return R.pathOr([], ['cardoList', data])(content);
  }

  // Else assume the CardoGroup data is supplied as a prop
  return data;
};

const mapStateToProps = ({ content, cardoList }, { data }) => ({
  data: getCardoListData({ content, data }),
  showMoreText: R.path(['cardoList', 'showMoreText'], content),
  cardoList,
});

const mapDispatchToProps = dispatch => ({
  initialiseCardoList: ({ id }) => dispatch(initialiseCardoListAction({ id })),
  showMore: ({ id }) => dispatch(showMoreAction({ id })),
  hideShowMore: ({ id }) => dispatch(hideShowMoreAction({ id })),
});

CardoListContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardoListContainer);
